import React from "react"
import { routerBaseSubpath } from "utils/dom"

function ErrorPage(props: { error: Error }): JSX.Element {
  const { error } = props

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100">
      <div className="text-center container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <h1 className="display-4 text-danger mb-4">Oops!</h1>
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h2 className="h4 mb-3">
                  Aconteceu algo estranho nessa sessão
                </h2>
                {error && (
                  <div className="text-muted">
                    <p className="font-weight-bold mb-2">Detalhes do erro:</p>
                    <div className="bg-light p-3 rounded position-relative">
                      <small className="text-monospace">
                        {error.message || String(error)}
                      </small>
                      <button
                        className="btn btn-sm btn-outline-secondary border-0"
                        style={{
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          opacity: "0.5",
                        }}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            error.message || String(error)
                          )
                        }}
                      >
                        <i className="mdi mdi-content-copy"></i>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <button
              onClick={() =>
                (window.location.href = `${
                  window.location.origin
                }/${routerBaseSubpath()}`)
              }
              className="btn btn-primary btn-lg"
            >
              Voltar para a página inicial
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
